export default __webpack_public_path__ + "static/media/terminos.84872a2e.pdf";